import React from 'react';
export default function Footer() {
  return (
    <div className="footer">
    <a className='footer-icon'
    target="_blank"
    rel="noopener noreferrer"
       href="https://www.facebook.com/profile.php?id=61575049333494"
       role="button"
       ><i className="fab fa-facebook-f"></i></a>
    <a className='footer-icon'
    target="_blank"
    rel="noopener noreferrer"
       href="https://www.instagram.com/interpretersconnect?igsh=MXBlcTl4N3hoM3R4YQ=="
       role="button"
       ><i className="fab fa-instagram"></i></a>
    <a className='footer-icon'
    target="_blank"
    rel="noopener noreferrer"
       href="https://g.co/kgs/QFDzaLi"
       role="button"
       ><i className="fab fa-google"></i></a>
        <a className='footer-icon'
        target="_blank"
        rel="noopener noreferrer"
       href="mailto:info@interpretersconnectllc.com"
       role="button"
       ><i className="fas fa-envelope"></i></a>
  </div>
  );
}